export function shouldShowChatUnreadIndicator({
  hasResponseUnread,
  hasSharingNotification,
  isProcessing,
}: {
  hasResponseUnread: boolean
  hasSharingNotification: boolean
  isProcessing: boolean
}): boolean {
  return !isProcessing && (hasResponseUnread || hasSharingNotification)
}
